import { render, staticRenderFns } from "./RemoveCircleIcon.vue?vue&type=template&id=b55819ce&"
import script from "./RemoveCircleIcon.vue?vue&type=script&lang=ts&"
export * from "./RemoveCircleIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports